import { chipStyle, labelStyle } from "./filters/styles";

/**
 * Ownership filter, multi-select. Picking co-op AND condo means "either", not "both".
 *
 * Chips rather than a multiple <select>: a native multi-select needs ctrl/cmd-click to add a
 * second value and gives no sign that it can hold more than one, which is how the single-value
 * version here read for months. The buckets match services/listing_filters.OWNERSHIP_SQL, the
 * one place the SQL for each is defined.
 */
export const OWNERSHIP_OPTIONS = [
  { value: "condo", label: "Condo" },
  { value: "coop", label: "Co-op" },
  { value: "rental", label: "Rental bldg" },
  { value: "townhouse", label: "Townhouse / House" },
  { value: "multi", label: "Multi family" },
];

export default function OwnershipSelect({ selected = [], onChange, label = "Ownership" }) {
  const toggle = (v) =>
    onChange(selected.includes(v) ? selected.filter((x) => x !== v) : [...selected, v]);

  return (
    <div>
      <label style={labelStyle}>
        {label}
        {selected.length > 0 && (
          <span
            role="button"
            tabIndex={0}
            onClick={() => onChange([])}
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onChange([]); } }}
            style={{ marginLeft: "8px", fontWeight: 400, color: "#1976d2", cursor: "pointer" }}
          >
            clear
          </span>
        )}
      </label>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", paddingTop: "2px" }}>
        {OWNERSHIP_OPTIONS.map((o) => (
          <span
            key={o.value}
            role="button"
            tabIndex={0}
            onClick={() => toggle(o.value)}
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggle(o.value); } }}
            style={chipStyle(selected.includes(o.value))}
          >
            {o.label}
          </span>
        ))}
      </div>
    </div>
  );
}
